'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {Button} from '../../../components/buttons/Button';
import {NavigationBreadcrumb} from '../../../components/views/NavigationBreadcrumb';
import {ViewHeader} from '../../../components/views/ViewHeader';
import {I18nComponent} from '../../../core-utilities/react-i18n';


export function BasePersonnelViewTeamTypesHeaderView(props) {
  return (
    <ViewHeader
      className="LegacyHeader"
      showBackButton={true}
      onGoBack={props.onGoBack}
    >
      <div className="ProjectLayout__header">
        <div className="ProjectLayout__headerLeft">
          <NavigationBreadcrumb
            className="ProjectLayout__breadcrumb"
            path={props.breadcrumbPath}
          />
          <div className="ProjectLayout__title">
            {props.viewTitle}
          </div>
        </div>

        <div className="ProjectLayout__headerRight">
          <Button
            className="PersonnelViewTeamTypesHeader__createButton"
            label={props.createLabel}
            onClick={props.onClickCreate}
          />
        </div>
      </div>
    </ViewHeader>
  );
}

BasePersonnelViewTeamTypesHeaderView.propTypes = {
  className: T.string,

  onGoBack: T.func,
  onClickCreate: T.func,

  viewTitle: T.string,
  createLabel: T.string,
};

export const PersonnelViewTeamTypesHeaderView = I18nComponent(BasePersonnelViewTeamTypesHeaderView, [
  {code: 'teams.types.manage.header.label', prop: 'viewTitle'},
  {code: 'default.create.button.label', prop: 'createLabel'},
]);

// Required for legacy angular inter-op
PersonnelViewTeamTypesHeaderView.propTypes = {
  className: T.string,

  onClickCreate: T.func,
};



// WEBPACK FOOTER //
// ./src/js/personnel/components/PersonnelViewTeamTypesHeader/PersonnelViewTeamTypesHeaderView.js